import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  emailTemplateURL,
  emailUpdateURL,
  fetchemailTemplateURL
} from "../utils/constants/apiEndPoints";
import privateAxios from "../utils/axiosPrivate";
import { showToast } from "../utils/utils";
import { showToastType } from "../utils/constants/appConstants";
import { commonErrMsg } from "../locales/en";

const initialState = {
  loading: false,
  emailByIdLoading: false
};

const emailTemplateLogSlice = createSlice({
  name: "emailActivityLog",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmailTemplateThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEmailTemplateThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(fetchEmailTemplateThunk.rejected, (state) => {
        state.loading = false;
      })
      // === Update Email Template ===

      .addCase(updateEmailTemplateThunk.fulfilled, (_, action) => {
        showToast(action.payload?.data?.message, showToastType.success);
      })
      .addCase(updateEmailTemplateThunk.rejected, (_, action) => {
        const error = action.payload?.data;
        const errorMessage =
          error?.response?.data?.errors?.[0] ||
          error?.response?.data?.message ||
          error.message ||
          commonErrMsg.item3;
        showToast(errorMessage, showToastType.error);
      })

      // === Get Single Email Template By ID ===
      .addCase(getEmailTemplateByIdThunk.pending, (state) => {
        state.emailByIdLoading = true;
      })
      .addCase(getEmailTemplateByIdThunk.fulfilled, (state) => {
        state.emailByIdLoading = false;
      })
      .addCase(getEmailTemplateByIdThunk.rejected, (state, action) => {
        state.emailByIdLoading = false;
        const error = action.payload;
        const errorMessage =
          error?.response?.data?.errors?.[0] ||
          error?.response?.data?.message ||
          error.message ||
          commonErrMsg.item2;
        showToast(errorMessage, showToastType.error);
      });
  }
});

export const fetchEmailTemplateThunk = createAsyncThunk(
  "emailtemplate/fetchEmailTemplate",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(emailTemplateURL, {
        params: payload
      });
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateEmailTemplateThunk = createAsyncThunk(
  "emailtemplate/updateEmailTemplateStatus",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.patch(
        emailUpdateURL(Number(payload))
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Add this to your thunk definitions

export const getEmailTemplateByIdThunk = createAsyncThunk(
  "emailtemplate/getEmailTemplateById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(fetchemailTemplateURL(id));
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export default emailTemplateLogSlice.reducer;
